module.exports = __webpack_public_path__ + "static/en-595f5680925b3a1a70100efdaa8d2f72.png";